import { WidgetType } from 'widgets/WidgetType.ts';
import State from 'store/State.ts';
import {
    HistoricalPercentageChangeConfig,
    HistoricalPercentageChangeConfigPayloadType,
} from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';
import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
} from 'widgets/store/configuration/configSlice.ts';
import { combineReducers } from 'redux';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory.ts';
import { HistoricalPercentageChangeWidgetState } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeWidgetsState.ts';
import { selectWidgetInstancesState } from 'widgets/store/selectors.ts';
import { buildEstimatedTradeCostComparisonWidgetConfigSlice } from 'widgets/estimatedTradeCost/widget-comparison/store/configslice.ts';
import { HistoricalPercentageChangeWidgetGridColumn } from 'widgets/historicalPercentageChange/widget/components/grid/columns.ts';

export const useEstimatedTradeCostComparisonWidgetConfigSlice = () =>
    useConfigSlice(buildEstimatedTradeCostComparisonWidgetConfigSlice());

export const buildHistoricalPercentageChangeStoreSlice = (
    widgetType:
        | WidgetType.HistoricalPercentageChangeCapsule
        | WidgetType.HistoricalPercentageChangeWidget,
    initialConfigState: HistoricalPercentageChangeConfig
) => {
    const selectWidgetsState = (state: State) =>
        selectWidgetInstancesState(state)[widgetType];

    const selectWidgetState = (state: State, widgetKey: string) =>
        selectWidgetsState(state)[widgetKey];

    const configSlice = buildConfigSliceWithGridSupport<
        HistoricalPercentageChangeWidgetGridColumn,
        HistoricalPercentageChangeConfig
    >(widgetType, selectWidgetState, initialConfigState);

    const { reducer: configReducer } = configSlice;

    const widgetStateReducer =
        combineReducers<HistoricalPercentageChangeWidgetState>({
            config: configReducer,
        });

    const reducer = createWidgetsReducer<
        HistoricalPercentageChangeWidgetState,
        HistoricalPercentageChangeConfigPayloadType
    >(widgetType, widgetStateReducer);

    return { configSlice, reducer };
};
